export function getCodexInfo(codexid: string){
  const query = [
    "SELECT DISTINCT ?codex ?expression ?codex_title ?item_expression_title ?item_expression_question_title ?surface ?surface_title ?surface_order ?manifestation ?manifestation_short_id ?status ?toplevel ?toplevel_title ?author ?authorTitle ", 
    "{",
      "BIND(<" + codexid + "> as ?codex) . ",
      "?codex <http://purl.org/dc/elements/1.1/title> ?codex_title .",
      "OPTIONAL {",
      "?icodex <http://scta.info/property/isCodexItemOf> ?codex .",
      "?isurface <http://purl.org/dc/elements/1.1/isPartOf> ?icodex .",
      "?surface <http://scta.info/property/hasISurface> ?isurface .",
      "?surface <http://scta.info/property/order> ?surface_order .",
      "?surface <http://purl.org/dc/elements/1.1/title> ?surface_title .",
      "?manifestation <http://scta.info/property/isOnSurface> ?surface .",
      "?manifestation <http://scta.info/property/structureType> <http://scta.info/resource/structureItem> .",
      "?manifestation <http://scta.info/property/shortId> ?manifestation_short_id .",
      "?manifestation <http://scta.info/property/isManifestationOf> ?expression .",
      "?expression <http://scta.info/property/isPartOfTopLevelExpression> ?toplevel .",
      "?toplevel <http://purl.org/dc/elements/1.1/title> ?toplevel_title .",
      "?toplevel <http://www.loc.gov/loc.terms/relators/AUT> ?author .",
      "?author <http://purl.org/dc/elements/1.1/title> ?authorTitle .",
      "?expression <http://purl.org/dc/elements/1.1/title> ?item_expression_title .",
      "?expression <http://scta.info/property/status> ?status .",
      "OPTIONAL {",
         "?expression <http://scta.info/property/questionTitle> ?item_expression_question_title .",
       "}",
     "}",
    "}",
    "ORDER BY ?surface_order"].join('')
 return query
}
export function getCodexInfoFromManifest(manifestid: string){
const query = [
  "SELECT DISTINCT ?codex ?expression ?codex_title ?item_expression_title ?item_expression_question_title ?surface ?surface_title ?surface_order ?manifestation ?manifestation_short_id ?status ?toplevel ?toplevel_title ?author ?authorTitle ",
  "{",
    "?icodex <http://scta.info/property/hasOfficialManifest> <" + manifestid + "> .",
    "?codex <http://scta.info/property/hasCodexItem> ?icodex .",
    "?codex <http://purl.org/dc/elements/1.1/title> ?codex_title .",
    "OPTIONAL {",
    "?icodex <http://scta.info/property/isCodexItemOf> ?codex .",
    "?isurface <http://purl.org/dc/elements/1.1/isPartOf> ?icodex .",
    "?surface <http://scta.info/property/hasISurface> ?isurface .",
    "?surface <http://scta.info/property/order> ?surface_order .",
    "?surface <http://purl.org/dc/elements/1.1/title> ?surface_title .",
    "?manifestation <http://scta.info/property/isOnSurface> ?surface .",
    "?manifestation <http://scta.info/property/structureType> <http://scta.info/resource/structureItem> .",
    "?manifestation <http://scta.info/property/shortId> ?manifestation_short_id .",
    "?manifestation <http://scta.info/property/isManifestationOf> ?expression .",
    "?expression <http://scta.info/property/isPartOfTopLevelExpression> ?toplevel .",
    "?toplevel <http://purl.org/dc/elements/1.1/title> ?toplevel_title .",
    "?toplevel <http://www.loc.gov/loc.terms/relators/AUT> ?author .",
    "?author <http://purl.org/dc/elements/1.1/title> ?authorTitle .",
    "?expression <http://purl.org/dc/elements/1.1/title> ?item_expression_title .",
    "?expression <http://scta.info/property/status> ?status .",
    "OPTIONAL {",
       "?expression <http://scta.info/property/questionTitle> ?item_expression_question_title .",
     "}",
   "}",
  "}",
  "ORDER BY ?surface_order"].join('')
  return query
}

 export function getCodexInfoFromSurface(surfaceid: string){
  const query = [
    "SELECT DISTINCT ?codex ?expression ?codex_title ?item_expression_title ?item_expression_question_title ?surface ?surface_title ?surface_order ?manifestation ?manifestation_short_id ?status ?toplevel ?toplevel_title ?author ?authorTitle ",
    "{",
      "?codex <http://scta.info/property/hasSurface> <" + surfaceid + "> .",
      "?codex <http://purl.org/dc/elements/1.1/title> ?codex_title .",
      "OPTIONAL {",
      "?icodex <http://scta.info/property/isCodexItemOf> ?codex .",
      "?isurface <http://purl.org/dc/elements/1.1/isPartOf> ?icodex .",
      "?surface <http://scta.info/property/hasISurface> ?isurface .",
      "?surface <http://scta.info/property/order> ?surface_order .",
      "?surface <http://purl.org/dc/elements/1.1/title> ?surface_title .",
      "?manifestation <http://scta.info/property/isOnSurface> ?surface .",
      "?manifestation <http://scta.info/property/structureType> <http://scta.info/resource/structureItem> .",
      "?manifestation <http://scta.info/property/shortId> ?manifestation_short_id .",
      "?manifestation <http://scta.info/property/isManifestationOf> ?expression .",
      "?expression <http://scta.info/property/isPartOfTopLevelExpression> ?toplevel .",
      "?toplevel <http://purl.org/dc/elements/1.1/title> ?toplevel_title .",
      "?toplevel <http://www.loc.gov/loc.terms/relators/AUT> ?author .",
      "?author <http://purl.org/dc/elements/1.1/title> ?authorTitle .",
      "?expression <http://purl.org/dc/elements/1.1/title> ?item_expression_title .",
      "?expression <http://scta.info/property/status> ?status .",
      "OPTIONAL {",
         "?expression <http://scta.info/property/questionTitle> ?item_expression_question_title .",
       "}",
     "}",
    "}",
    "ORDER BY ?surface_order"].join('')
 return query
}

export function getCodexInfoFromCanvas(canvasid: string){
const query = [
  "SELECT DISTINCT ?codex ?surfaceFocus ?expression ?codex_title ?item_expression_title ?item_expression_question_title ?surface ?surface_title ?surface_order ?manifestation ?manifestation_short_id ?status ?toplevel ?toplevel_title ?author ?authorTitle ",
  "{",
    "?isurfaceFocus <http://scta.info/property/hasCanvas> <" + canvasid + "> .",
    "?surfaceFocus <http://scta.info/property/hasISurface> ?isurfaceFocus .",
    "?codex <http://scta.info/property/hasSurface> ?surfaceFocus .",
    "?codex <http://purl.org/dc/elements/1.1/title> ?codex_title .",
    "OPTIONAL {",
    "?icodex <http://scta.info/property/isCodexItemOf> ?codex .",
    "?isurface <http://purl.org/dc/elements/1.1/isPartOf> ?icodex .",
    "?surface <http://scta.info/property/hasISurface> ?isurface .",
    "?surface <http://scta.info/property/order> ?surface_order .",
    "?surface <http://purl.org/dc/elements/1.1/title> ?surface_title .",
    "?manifestation <http://scta.info/property/isOnSurface> ?surface .",
    "?manifestation <http://scta.info/property/structureType> <http://scta.info/resource/structureItem> .",
    "?manifestation <http://scta.info/property/shortId> ?manifestation_short_id .",
    "?manifestation <http://scta.info/property/isManifestationOf> ?expression .",
    "?expression <http://scta.info/property/isPartOfTopLevelExpression> ?toplevel .",
    "?toplevel <http://purl.org/dc/elements/1.1/title> ?toplevel_title .",
    "?toplevel <http://www.loc.gov/loc.terms/relators/AUT> ?author .",
    "?author <http://purl.org/dc/elements/1.1/title> ?authorTitle .",
    "?expression <http://purl.org/dc/elements/1.1/title> ?item_expression_title .",
    "?expression <http://scta.info/property/status> ?status .",
    "OPTIONAL {",
       "?expression <http://scta.info/property/questionTitle> ?item_expression_question_title .",
     "}",
   "}",
  "}",
  "ORDER BY ?surface_order"].join('')
  return query
}